/**************************************************
 * Nombre:       ExportadorDatosLista
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Fechas from "../Formularios/Formulario_Fechas";
import {CloudDownload} from '@mui/icons-material'
import {useState} from "react";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";
import * as XLSX from 'xlsx';
import {saveAs} from 'file-saver';
import {adaptador_lista_exportacion} from "../Adaptadores/adaptador_lista_exportacion";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import dayjs from "dayjs";

const ExportadorDatosListaConductor = ({conductor}) => {
    const {sCell} = useResponsive()
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: {}})
    const [cargando, setCargando] = useState(false)

    const exportarDatos = async () => {

        let entidad = await obtenerEntidad()
        let fechaIni = new Date(entidad.fechaInicio).setHours(0,0,0,0)
        let fechaFin = new Date(entidad.fechaFinal).setHours(23, 59, 59, 0)

        console.log(dayjs(fechaIni).format('DD hh:mm:ss'))
        console.log(dayjs(fechaFin).format('DD hh:mm:ss'))


        let w = [where('fecha', '>=', fechaIni), where('fecha', '<=', fechaFin), where('idConductor', '==', conductor.id)]
        setCargando(true)
        let dox = await obtenerColWheres({col: 'listascheckeo', wheres: w})
      //  console.log(dox)
        if (dox.res) {
            let arr = adaptador_lista_exportacion(dox.data)
            const libroHuspes = XLSX.utils.json_to_sheet(arr)
            const workbook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(workbook, libroHuspes, "LISTAS")

            // Buffer to store the generated Excel file
            const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
            const blob = new Blob([excelBuffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'});

            saveAs(blob, "Listas de Chequeo.xlsx");

        }
        setCargando(false)

    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
            sx={{pl: 2}}

        >

            <Grid container size={{xs: 12, sm: 12, md: 8}}>
                <Formulario_Fechas props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 4}} justifyContent={sCell ? 'center' : 'flex-start'}>
                <Button
                    onClick={() => exportarDatos()}
                    loading={cargando} variant={'outlined'}
                    startIcon={<CloudDownload/>}>Exportar</Button>
            </Grid>


        </Grid>
    )

}
export default ExportadorDatosListaConductor